import { Fade, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React, { memo } from 'react'

import { RatePlanWithSelectoption } from '../../types/accommodation'
import useStyles from './index.styles'

interface RatePlanItemSmallBoxForContractProps {
  ratePlan: RatePlanWithSelectoption
  onToggle: (id: string) => void
  className?: string
  skeleton?: boolean
}

const RatePlanItemSmallBoxForContract: React.FC<
  RatePlanItemSmallBoxForContractProps
> = ({ ratePlan, onToggle, className, skeleton }) => {
  const classes = useStyles()
  const {
    selected,
    roomTypeName,
    displayRoomTypeCode,
    name,
    displayRatePlanCode,
    providerName
  } = ratePlan

  return (
    <div
      className={[
        classes.root,
        selected ? classes.active : '',
        className || ''
      ].join(' ')}
      role="presentation"
      onClick={() => {
        if (ratePlan.id) {
          onToggle(ratePlan.id)
        }
      }}>
      <Fade in={selected} timeout={250}>
        <span className={classes.activeCircle} />
      </Fade>
      <Typography className={classes.providerText} variant="h4">
        {skeleton ? (
          <Skeleton animation="wave" className={classes.skeleton} />
        ) : (
          <>{providerName}</>
        )}
      </Typography>
      <Typography variant="h5" className={classes.roomTypeText}>
        {skeleton ? (
          <Skeleton animation="wave" className={classes.skeleton} />
        ) : (
          `${roomTypeName} (${displayRoomTypeCode})`
        )}
      </Typography>
      <Typography variant="body1" className={classes.ratePlanText}>
        {skeleton ? (
          <Skeleton animation="wave" className={classes.skeleton2} />
        ) : (
          name
        )}
      </Typography>
      <Typography variant="body1">
        {skeleton ? (
          <Skeleton animation="wave" className={classes.skeleton} />
        ) : (
          `(${displayRatePlanCode})`
        )}
      </Typography>
    </div>
  )
}

export default memo(RatePlanItemSmallBoxForContract)
